import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

const OSPanel = ({ children, className, hover = true, ...props }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      whileHover={hover ? { y: -5, boxShadow: "0 20px 40px -10px var(--glass-border)" } : {}}
      transition={{ duration: 0.4, ease: "easeOut" }}
      className={cn(
        // BASE STYLES
        "relative overflow-hidden rounded-3xl backdrop-blur-xl transition-all duration-500",
        // THEME VARIABLES (Critical for Light/Dark support)
        "bg-[var(--glass-bg)] border border-[var(--glass-border)] text-[var(--text-main)]",
        className
      )}
      {...props}
    >
      {/* Subtle Gradient Noise Overlay */}
      <div className="absolute inset-0 opacity-[0.03] bg-[url('https://grainy-gradients.vercel.app/noise.svg')] pointer-events-none" />
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
      
      {/* Reflection Shine */}
      <div className="absolute inset-0 bg-gradient-to-tr from-white/5 to-transparent pointer-events-none z-20 mix-blend-overlay" />
    </motion.div>
  );
};

export default OSPanel;
